import { connect } from "react-redux"

import { unregisterCustomField } from "shared/customFields/action-creators"
import { customFieldFormSectionConnection } from "shared/customFields/selectors"
import CustomFieldFormSection from "app/static/frontend/custom-fields/components/CustomFieldFormSection"

export default connect(customFieldFormSectionConnection, { unregisterCustomField })(CustomFieldFormSection)
